/* @flow */

import React from 'react';
import { Message, Form, Icon } from 'semantic-ui-react';

type Props = {
  block: EditorialYoutubeBlock,
};

const View = ({ block }: Props) => {
  if (block.page) {
    return (
      <Form>
        <Form.Input
          label="Titre"
          value={block.title || (block.page && block.page.name)}
          readOnly
        />
        <Form.Input
          iconPosition="left"
          label="Liaison vers la page"
          defaultValue={block.page.name}
          readOnly
        >
          <Icon name="chevron right" />
          <input />
        </Form.Input>
      </Form>
    );
  }

  return <Message icon="info" header="Aucune page spécifiée" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/page/View.js